import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=77ae12c8&scoped=true&"
import script from "./reset-password.js?vue&type=script&lang=js&"
export * from "./reset-password.js?vue&type=script&lang=js&"
import style0 from "./reset-password.css?vue&type=style&index=0&id=77ae12c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ae12c8",
  null
  
)

export default component.exports